import React from "react";
import { Link } from "react-router-dom";
import Logo from "../../components/logo/Logo";
import FooterData from "../../data/Footer/footerItem.json";
import FooterLinkItem from "../../components/Footer/FooterLinkItem.jsx";

const Footer = () => {
  return (
    <div className="footer-section section footer-bg-color">
      <div className="container">
        <div className="row mb-lg-14 mb-md-10 mb-6">
          <div className="col-xl-4 col-lg-4 col-md-4 col-sm-6 col-12 col-12 mb-6">
            <div className="footer-widget">
              <div className="footer-logo">
               
                <Logo
                  image={`${process.env.PUBLIC_URL}/images/logo/newFooter.png`}
                />
              </div>
              <div className="footer-widget-content">
                <div className="content">
                  {/* <p>
                    <Link to={process.env.PUBLIC_URL + "/"}>
                      +91 9910507976
                    </Link>
                  </p> */}
                  <p>
                    <Link to={process.env.PUBLIC_URL + "/"}>
                    contact@tawanai.nl

                    </Link>{" "}
                  </p>
                </div>
                <div className="footer-social-inline">
                  <a
                    href="https://www.linkedin.com/company/tawanai-energytech/"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <i className="fab fa-linkedin"></i>
                  </a>
                  {/* <a
                    href="https://www.facebook.com/"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <i className="fab fa-facebook-square"></i>
                  </a> */}
                </div>
                <div className="footer-locations-compact mt-3">
                  <h5 className="footer-widget-title">Our Locations</h5>
                  <div className="footer-widget-content">
                    <div className="d-flex flex-wrap footer-locations-inline">
                      <div className="location-item mb-2 mb-md-0 pr-3 pr-lg-4">
                        <p className="mb-0">
                          <strong>Tawanai B.V.</strong>
                          <br />
                          WEENA 690, 3012 CN
                          <br />
                          Rotterdam, Netherlands
                        </p>
                      </div>
                      <div className="location-item pr-3 pr-lg-4">
                        <p className="mb-0">
                          <strong>Tawanai</strong>
                          <br />
                          CoWrks Worldmark-1, Aerocity
                          <br />
                          New Delhi-110037
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {FooterData &&
            FooterData.map((single, key) => {
              return (
                <div
                  key={key}
                  className="col-xl-2 col-lg-2 col-md-4 col-sm-6 col-6 mb-6"
                >
                  <FooterLinkItem data={single} key={key} />
                </div>
              );
            })}
        </div>

        <div className="row">
          {/* <div className="col">
                        <p className="copyright">&copy; 2021 <strong>Exomac</strong> Made with <i className="fas fa-heart text-danger"></i> by <a target="_blank" rel="noopener noreferrer" href="https://hasthemes.com/"><strong>HasThemes</strong></a>.</p>
                    </div> */}
          <div className="col">
            <p className="copyright">
              &copy; 2026 <strong>Tawanai |</strong> Powered by{" "}
              <a target="_blank" rel="noopener noreferrer">
                <strong>Tawanai</strong>
              </a>{" "}
              <i className="fa fa-bolt" aria-hidden="true"></i>
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Footer;
